module.exports = __webpack_public_path__ + "static/media/mint-subHeader-Yellow.a0762ec3.png";